var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.maxStars')}},[_c('el-input-number',{staticClass:"hide-spin-button",staticStyle:{"width":"100%"},attrs:{"min":1,"max":10},model:{value:(_vm.optionModel.max),callback:function ($$v) {_vm.$set(_vm.optionModel, "max", $$v)},expression:"optionModel.max"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }